/*
 * @Author: enshengcao 2436094419@qq.com
 * @Date: 2024-01-15 14:04:29
 * @LastEditors: enshengcao 2436094419@qq.com
 * @LastEditTime: 2024-03-28 17:10:46
 * @FilePath: /app-inspection/src/api/inspection/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '../http'

// 1.获取待处理
export const getInfoTodoForApp = data => {
    return http(`/app-api/inspection/info/getInfoTodoForApp?deviceType=${data.deviceType}`, 'get', data)
}
//2.获取已处理
export const getInfoDoneForApp = data => {
    return http(`/app-api/inspection/info/getInfoDoneForApp?pageNo=${data.pageNo}&pageSize=${data.pageSize}&deviceType=${data.deviceType}&projectName=${data.projectName}&reportNumber=${data.reportNumber}`, 'get', data)
}
//3.获取我发起
export const getInfoCreateForApp = data => {
    return http(`/app-api/inspection/info/getInfoCreateForApp?pageNo=${data.pageNo}&pageSize=${data.pageSize}&deviceType=${data.deviceType}&projectName=${data.projectName}&reportNumber=${data.reportNumber}`, 'get', data)
}
//4.获取我管理
export const getInfoManageForApp = data => {
    return http(`/app-api/inspection/info/getInfopageForApp?pageNo=${data.pageNo}&pageSize=${data.pageSize}&deviceType=${data.deviceType}&projectName=${data.projectName}&reportNumber=${data.reportNumber}`, 'get', data)
}
// //草稿中的长按删除接口
export const draftDelete = data => {
    return http(`/app-api/inspection/info/delete?id=${data.id}`, 'delete', data)
}
// // 查看审批记录 已处理 我发起页面
// export const getAllHistoryByInfoId= data => {
//   return http(`/app-api/inspection/info-result-history/getAllHistoryByInfoId?infoId=${data.infoId}`, 'get', data)
// }

// 创建召回申请
export const createRecall = data => {
    return http(`/app-api/inspection/recall/create`, 'post', data)
}

// 驳回召回申请
export const rejectTaskRecall = data => {
    return http(`/app-api/inspection/recall/reject-task`, 'post', data)
}

// 通过召回申请
export const approveAssignTaskRecall = data => {
    return http(`/app-api/inspection/recall/approve-assign-task`, 'post', data)
}

// 完成最终召回申请
export const approvalFinalTaskRecall = data => {
    return http(`/app-api/inspection/recall/approval-final-task`, 'post', data)
}
// 获得召回申请任务类型
export const getTaskTypeRecall = data => {
    return http(`/app-api/inspection/recall/getTask-type`, 'post', data)
}

// 获得info的历史类型
export const getListHistory = data => {
    return http(`/app-api/inspection/recall/list-history?infoId=${data.infoId}`, 'post', data)
}
// 获取项目列表
export const getProjectList = data => {

    return http(`/app-api/info/rule-permission/getProjectForApp?module=inspection&roleCode=${data.roleCode}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&prjConfigId=` + data.prjConfigId + '&queryStr=' + data.queryStr, 'get', data)
}

// 新增判断是否是四级流程
export const decideCheckSum = data => {

    return http(`/app-api/inspection/info/decideCheckSum?infoId=${data.infoId}`, 'get', data)
}

// 获取四级流程的校核人员
export const getChecksumMemberByInfoId = data => {

    return http(`/app-api/info/rule-permission/getChecksumMemberByInfoId?infoId=${data.infoId}`, 'get', data)
}
